module.exports = __webpack_public_path__ + "assets/img/team/monika-rychtarikova.jpg";